module.exports = __webpack_public_path__ + "img/bitcoin.com_1.f6c32082.png";